import { render, staticRenderFns } from "./GobackButton.vue?vue&type=template&id=680ea5bf&scoped=true&"
import script from "./GobackButton.vue?vue&type=script&lang=js&"
export * from "./GobackButton.vue?vue&type=script&lang=js&"
import style0 from "./GobackButton.vue?vue&type=style&index=0&id=680ea5bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680ea5bf",
  null
  
)

export default component.exports